var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-menu',{attrs:{"home":"/admin","color":"#1f1161"}})}
var staticRenderFns = []

export { render, staticRenderFns }